module.exports = __webpack_public_path__ + "img/warehouse.670980b0.svg";